import { Center, Text } from '@mantine/core';
import type { PropsWithChildren } from 'react';
export type BlogFilterLabelProps = {
  label: string;
};
export const BlogFilterLabel: React.FC<PropsWithChildren<BlogFilterLabelProps>> = ({
  children,
  label
}) => {
  return <Center style={{
    gap: 8
  }}>
      {children}
      <Text inherit tt="capitalize">
        {label}
      </Text>
    </Center>;
};